import { Box, Card, CardHeader, Grid } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Accordion, {
  AccordionScheduleProps
} from '../accordion/AccordionScheduleDay'
import Typography from '../base/Typography'
import PackageJobVisitLink, {
  PackageJobVisitProps
} from '../button/PackageJobVisitLink'
import Icon from '../icons/Icons'
import Tags, { TagInterface } from '../tags/Tags'
import PopOver, { CardPopoverProps } from './CardPopover'

export interface JobAssignment {
  id: string
  packageCode: string
  cleaner?: string
  client: string
  startDate: string
  endDate: string
}

export type CardJobAssignmentProps = {
  job: JobAssignment
  tags: TagInterface[]
} & AccordionScheduleProps &
  CardPopoverProps &
  PackageJobVisitProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 275,
      borderRadius: 4,
      padding: theme.spacing(2)
    },
    cardHeader: {
      padding: 0,
      marginBottom: theme.spacing(2)
    },
    cardContentCleaner: {
      display: 'grid',
      gridTemplateColumns: 'min-content 1fr',
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(2),
      gridColumnGap: theme.spacing(1)
    },
    linkColor: {
      color: theme.palette.info.main
    },
    textColor: {
      color: theme.palette.grey[800]
    },
    nameLabel: {
      marginRight: theme.spacing(4)
    },
    startLabel: {
      marginRight: theme.spacing(1.2)
    },
    endLabel: {
      marginRight: theme.spacing(1.9)
    },
    hideDisplay: {
      display: 'none'
    }
  })
)

const CardJobAssignment: React.FC<CardJobAssignmentProps> = (props) => {
  const { schedule, job, tags, data, packageJobVisit } = props
  const classes = useStyles()
  return (
    <Card elevation={1} classes={{ root: classes.root }}>
      <CardHeader
        className={classes.cardHeader}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2" children="Job Details" />
            <Box display="flex" alignItems="center">
              <PackageJobVisitLink {...packageJobVisit} jobId={job?.id} />
              <Typography
                variant="caption"
                children={`| ${job ? job.packageCode : 'Missing'}`}
              />
            </Box>
          </Box>
        }
      />
      <Box
        className={
          job.cleaner ? classes.cardContentCleaner : classes.hideDisplay
        }
      >
        <Icon iconName="CleaningIcon" size="small" />
        <Typography variant="overline" children={job.cleaner} />
      </Box>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Box>
          <Typography
            className={`${classes.textColor} ${classes.nameLabel}`}
            variant="caption"
            children="Client:"
          />
          <Typography
            variant="caption"
            children={job ? job.client : 'Name Missing'}
          />
        </Box>
        <Box>
          <Typography
            className={`${classes.textColor} ${classes.startLabel}`}
            variant="caption"
            children="Start Date:"
          />
          <Typography
            variant="caption"
            children={job ? job.startDate : 'mm dd, yyyy'}
          />
        </Box>
        <Box>
          <Typography
            className={`${classes.textColor} ${classes.endLabel}`}
            variant="caption"
            children="End Date:"
          />
          <Typography
            variant="caption"
            children={job ? job.endDate : 'mm dd, yyyy'}
          />
        </Box>
        <Box>
          <Accordion sizes="xs" children="" schedule={schedule} />
        </Box>
      </Grid>
      <Box
        marginTop={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex">
          {tags.map((tag, index) => {
            return (
              <Box key={`tag-${index}`} marginRight={0.5}>
                <Tags
                  customVariant={tag ? tag.variant : 'homeCleaning'}
                  label={tag ? tag.label : 'Missing'}
                  sizes="xs"
                />
              </Box>
            )
          })}
        </Box>
        <PopOver data={data} />
      </Box>
    </Card>
  )
}

export default CardJobAssignment
